var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dynamic-crf',{attrs:{"crfId":"tbFrmHealthSocialCareResourceUse","crfTitle":"Health and Social Care Resource Use"}})
}
var staticRenderFns = []

export { render, staticRenderFns }